<div class="content">
  <form #dienstleistungsArtForm="ngForm" data-qa="kontakt-form">

    <header>
      <div>
      </div>

      <div class="buttons">

        <button matButton="outlined"
          data-qa="cancel-kontaktdaten-button"
          (click)="westnetzSidenavService.closeRightnav()">
          <mat-icon svgIcon="innogy_picto_close"></mat-icon>
          Schließen
        </button>

        <button matButton="filled"
          [disabled]="!dienstleistungsArtForm.form.valid"
          data-qa="submit-kontaktdaten-button"
          (click)="saveDienstleistungsArt()">
          <mat-icon>save</mat-icon>
          {{createNew ? 'Anlegen' : 'Speichern'}}
        </button>

        @if (!createNew) {
          <button matButton="filled"
            class="button-warn"
            data-qa="delete-kontaktdaten-button"
            (click)="deleteDienstleistungsart(dienstleistungsArt)">
            <mat-icon svgIcon="innogy_picto_bin_c-check"></mat-icon>
            Löschen
          </button>
        }

      </div>
    </header>

    <div class="detail-main">

      <fieldset>
        <legend>Dienstleistungsart {{createNew ? 'anlegen' : 'editieren'}}</legend>

        <mat-form-field redispatchProvideReadonly>
          <mat-label>Titel</mat-label>
          <input matInput
            maxlength="100"
            #title="ngModel"
            [(ngModel)]="dienstleistungsArt.title"
            id="title_{{dienstleistungsArt.id}}"
            name="title_{{dienstleistungsArt.id}}"
            data-qa="title"
            required/>
          @if (title?.errors?.required) {
            <mat-error>
              Bitte tragen Sie den Title ein
            </mat-error>
          }
        </mat-form-field>


        @for (module of availableDienstleistungsmodule$ | async; track module.id) {
          <mat-checkbox
            [checked]="containsModule(module.dienstleistungsmodule)"
            (change)="moduleChanged($event, module.dienstleistungsmodule)">
            {{module.title}}
          </mat-checkbox>
        }


        <mat-form-field redispatchProvideReadonly>
          <mat-label>Notizen</mat-label>
          <textarea matInput
            #notes="ngModel"
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            [(ngModel)]="dienstleistungsArt.notes"
            id="notes_{{dienstleistungsArt.id}}"
            name="notes_{{dienstleistungsArt.id}}"
            data-qa="notes"
            cdkAutosizeMinRows="5"
            cdkAutosizeMaxRows="10"
            >
          </textarea>
        </mat-form-field>

      </fieldset>
    </div>
  </form>
</div>
